import { render, staticRenderFns } from "./TermsAndConditions.vue?vue&type=template&id=5bbf9466"
import script from "./TermsAndConditions.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports